import { configureStore } from '@reduxjs/toolkit'
import { appState } from '@store/app'
import { userApi } from '@api/user'
import { leadsApi } from '@api/leads'
import { adminApi } from '@api/admin'
import { companiesApi } from '@api/companies'
import { citiesApi } from '@api/cities'
import { statisticApi } from '@api/statistic'
import { dealersApi } from '@api/dealers'
import { notesApi } from '@api/note'
import { notificationsApi } from '@api/notifications'

export const store = configureStore({
  reducer: {
    [appState.name]: appState.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [statisticApi.reducerPath]: statisticApi.reducer,
    [leadsApi.reducerPath]: leadsApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [companiesApi.reducerPath]: companiesApi.reducer,
    [citiesApi.reducerPath]: citiesApi.reducer,
    [dealersApi.reducerPath]: dealersApi.reducer,
    [notesApi.reducerPath]: notesApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    userApi.middleware,
    statisticApi.middleware,
    leadsApi.middleware,
    adminApi.middleware,
    companiesApi.middleware,
    citiesApi.middleware,
    dealersApi.middleware,
    notesApi.middleware,
    notificationsApi.middleware,
  ),
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
